import * as React from 'react';
import Menu from 'material-ui-popup-state/HoverMenu';
import MenuItem from '@material-ui/core/MenuItem';
import { Icon } from '@material-ui/core';

import {
  usePopupState,
  bindHover,
  bindMenu,
} from 'material-ui-popup-state/hooks';

type Menu = {
  label: string;
  onClick?: (a?: Menu) => void;
};
type IconMenuProps = {
  icon: string;
  menus: Menu[];
  htmlColor?: string;
  onClick?: (a?: Menu) => void;
};

export function IconMenu(props: IconMenuProps) {
  const { icon, menus, htmlColor } = props;
  const popupState = usePopupState({ variant: 'popover', popupId: 'demoMenu' });

  const onClick = (a: Menu) => () => {
    if (a.onClick) {
      a.onClick(a);
    }
    if (props.onClick) {
      props.onClick(a);
    }
    popupState.close();
  };

  return (
    <>
      <Menu
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 4 }}
      >
        {menus.map((a, i) => (
          <MenuItem key={i} onClick={onClick(a)}>
            {a.label}
          </MenuItem>
        ))}
      </Menu>
      <Icon
        style={{ paddingTop: 3, color: htmlColor || '#eee' }}
        {...bindHover(popupState)}
      >
        {' '}
        {icon}{' '}
      </Icon>
    </>
  );
}
